import React, { Component } from 'react'

// import Checkbox from 'material-ui/Checkbox';
import View from './view'
import { connect } from 'react-redux'

import { login } from '../../redux/actions'


const mapDispatchToProps = dispatch => {
    return {
        login: user => dispatch(login(user))
    };
};

const mapStateToprops = state => ({
    user: state.user
})

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            rememberMe: true
        }
    }

    onTextChange = (e) =>{
        this.setState({[e.target.name]:e.target.value})
    }

    componentWillReceiveProps = (props) => {
        let { user, history } = props;
        if (user.loggedIn) {
            history.push('/')
        }
    }

    login = (evt) => {
        evt.preventDefault()
        let { login } = this.props
        login(this.state)
    }

    render() {
        return (
            <View
            {...this.state}
            login={this.login}
            onTextChange={this.onTextChange}
            />
        )
    }
}

export default connect(mapStateToprops, mapDispatchToProps)(Login)
